import { render, staticRenderFns } from "./my_type.vue?vue&type=template&id=4932023f&scoped=true&"
import script from "./my_type.vue?vue&type=script&lang=js&"
export * from "./my_type.vue?vue&type=script&lang=js&"
import style0 from "./my_type.vue?vue&type=style&index=0&id=4932023f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4932023f",
  null
  
)

export default component.exports